import FractionDsnFraction from '@/generated/controls/fractionDsn/FractionDsnFraction.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: FractionDsnFraction
})
